import { parameters } from '../../constants/parameters';
import { Pagination } from '../../entities/pagination';
import { Video } from '../../entities/video';
import * as genericApi from './generic-api';
import FilterVideos from '../../entities/filter/videos';
import { getUnixTimestamp } from '../formatter/date';

export const list = (
  token: string,
  params?: Partial<FilterVideos>,
): Promise<{ items: Video[]; pagination: Pagination }> => {
  const query = { ...params };

  for (const key of ['created_at_from', 'created_at_to'] as const) {
    const date = query[key];

    delete query[key];
    if (date) {
      const timestamp = getUnixTimestamp(new Date(date));

      if (Number.isFinite(timestamp)) Object.assign(query, { [key]: timestamp });
    }
  }

  return genericApi.list<Video>(token, `${parameters.api.baseUrl}/videos-crud`, {
    limit: 24,
    sort: '-created_at,-id',
    with: ['category'],
    ...query,
  });
};

export const one = async (token: string, id: number): Promise<Video | null> => {
  const video = await genericApi.one<Video | null>(token, `${parameters.api.baseUrl}/videos-crud/${id}`, {
    with: ['category'],
  });

  return video?.id ? video : null;
};
